module.exports = __webpack_public_path__ + "img/homePageImg02.c58b0f6d.png";